<div class="flex flex-col gap-3 xxl:gap-4 w-full bg-[#1a1a1a] relative">
  <video #videoElement  class="w-full h-[500px]  xxl:h-[525px]" autoplay muted></video>
  <div class="flex justify-center items-center">
    <button (click)="startRecording()" [disabled]="!cameraReady" [ngClass]="{'hidden': isRecording}">
     <mat-icon class="mdi mdi-record-circle text-5xl  text-red-600 "></mat-icon>
    </button>

    <button *ngIf="isRecording" (click)="stopRecording()">
      <mat-icon class="mdi mdi-stop-circle-outline text-5xl  text-gray-200 hover:text-gray-100"></mat-icon>
    </button>
  </div>

  <div *ngIf="isRecording" class="absolute top-2 right-0 left-0 flex justify-center bg-transparent">
    <p class="text-white bg-red-700 font-bold px-3 py-1 rounded-lg "> 00:{{countdown.toString().padStart(2, '0')}} / 00:{{maxTime}} </p>
  </div>

  <button *ngIf="!isRecording" (click)="closeRecorder()" class="flex justify-center items-center px-2 hover:scale-105 absolute top-2 left-2">
      <mat-icon class="mdi mdi-close text-3xl text-white"></mat-icon>
  </button>

</div>
